import React, { useEffect, useRef, useState } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  SafeAreaView,
  Image,
  ImageBackground,
  TextInput,
  FlatList,
  Modal,
} from "react-native";
import { Octicons } from "@expo/vector-icons";
import { FontAwesome } from "@expo/vector-icons";
import { getmission } from "../../action/actionGet";
import { useRecoilState } from "recoil";
import { tokenState } from "../../reducer/reducer/reducer/Atom";
import { useIsFocused } from "@react-navigation/core";
import moment from "moment";
import { apiservice } from "../../service/service";
const { width, height } = Dimensions.get("window");
export default function teblelv({ navigation, data, getevent }) {
  const [modals, setModal] = useState(false);
  const [Data, setData] = useState("");
  const [token, setToken] = useRecoilState(tokenState);
  return (
    <View style={styles.back}>
      <Modal
        animationType="slide"
        transparent={true}
        visible={modals}
        onRequestClose={() => {
          setModal(!modals);
        }}
      >
        <View style={styles.backmodal}>
          <View style={styles.viewmodal}>
            <Text style={[styles.textdel, { marginTop: 20 }]}>
              ต้องการที่จะลบใช่หรือไม่
            </Text>

            <View
              style={{
                flexDirection: "row",
                marginTop: 50,
                alignSelf: "center",
              }}
            >
              <TouchableOpacity
                onPress={() => setModal(!modals)}
                style={[styles.touchadd1, { marginHorizontal: 10 }]}
              >
                <Text style={styles.textadd}>ยกเลิก</Text>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={async () => {
                  const res = await apiservice({
                    path: "/admin/deletereward?id=" + Data?.id,
                    method: "delete",
                    token: token?.accessToken,
                  });
                  if (res.status == 200) {
                    getevent();
                    setModal(!modals);
                  }
                }}
                style={[styles.touchadd1, { marginHorizontal: 10 }]}
              >
                <Text style={styles.textadd}>ยืนยัน</Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>

      <View style={styles.head}>
        <View style={[styles.viewhead, { width: "20%" }]}>
          <Text style={styles.texthead}>เลเวล</Text>
        </View>
        <View style={[styles.viewhead, { width: "30%" }]}>
          <Text style={styles.texthead}>เงื่อนไขที่ได้รับรางวัล</Text>
        </View>
        <View
          style={[styles.viewhead, { width: "40%", paddingHorizontal: 20 }]}
        >
          <Text style={styles.texthead}>ของรางวัล</Text>
        </View>
        <View style={[styles.viewhead, { width: "10%" }]}>
          <Text style={styles.texthead}></Text>
        </View>
      </View>
      <FlatList
        data={data}
        scrollEnabled={true}
        renderItem={({ index, item }) => {
          return (
            <View>
              <View
                style={[
                  styles.viewmain,
                  { backgroundColor: index % 2 ? "#F1F2F4" : "#fff" },
                ]}
              >
                <View style={[styles.viewdetail, { width: "20%" }]}>
                  <Text style={styles.textdate}>{item.lv}</Text>
                </View>
                <View style={[styles.viewdetail, { width: "30%" }]}>
                  <Text style={styles.textdate}>{item.description} ขึ้นไป</Text>
                </View>
                <View
                  style={[
                    styles.viewdetail,
                    {
                      width: "40%",
                    },
                  ]}
                >
                  <View
                    style={{
                      flexDirection: "row",
                      width: "45%",
                      alignItems: "center",
                      alignSelf: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Image
                      style={{
                        width: 35,
                        height: 35,
                        alignSelf: "center",
                        marginRight: 5,
                      }}
                      source={require("../../image/coin.png")}
                    />
                    <Text style={styles.textdate}>
                      {parseInt(item?.reward?.coinlv) +
                        parseInt(item?.reward?.coindis)}
                    </Text>
                  </View>
                  <View
                    style={{
                      flexDirection: "row",
                      width: "45%",
                      alignItems: "center",
                      alignSelf: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Image
                      style={{
                        width: 28,
                        height: 35,
                        alignSelf: "center",
                        marginRight: 5,
                      }}
                      source={require("../../image/Icon awesome-running.png")}
                    />
                    <Text style={styles.textdate}>{item?.reward?.cal}</Text>
                  </View>

                  <TouchableOpacity
                    onPress={() => {
                      setData(item);
                      setModal(!modals);
                    }}
                    style={[styles.viewdetail, { width: "10%" }]}
                  >
                    <Text style={styles.textdate}>ลบ</Text>
                  </TouchableOpacity>
                </View>
              </View>
            </View>
          );
        }}
      />
    </View>
  );
}
const styles = StyleSheet.create({
  back: {
    width: "100%",
    height: "80%",
    borderWidth: 0.05,
    borderColor: "#00000010",
    backgroundColor: "#fff",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    marginTop: 10,
  },
  head: {
    width: "100%",
    height: 50,
    flexDirection: "row",
    backgroundColor: "#F1F3F9",
  },
  viewhead: {
    justifyContent: "center",
  },
  texthead: {
    fontFamily: "Prompt-Regular",
    fontSize: 18,
    color: "#172B4D",
    alignSelf: "center",
  },
  viewdetail: {
    flexDirection: "row",
    justifyContent: "center",
  },
  img: {
    width: 180,
    height: 80,
    zIndex: 99,
    marginLeft: -20,
  },
  textdeil: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#393939",
    marginTop: 5,
    marginLeft: -15,
  },
  textdetail: {
    fontFamily: "Prompt-Regular",
    fontSize: 12,
    color: "#393939",
    marginLeft: -15,
  },
  viewmain: {
    flexDirection: "row",
    width: width * 0.825,
    height: 80,
    paddingHorizontal: 5,
  },
  textdate: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#172B4D",
    alignSelf: "center",
  },
  viewatc: {
    width: width * 0.18,
    height: 30,
    justifyContent: "space-between",
    alignSelf: "flex-end",
    marginBottom: 20,
    flexDirection: "row",
    marginRight: 20,
  },
  touchatc: {
    width: 30,
    height: 30,
    borderRadius: 15,
    borderWidth: 0.5,
    borderColor: "#8898AA",
    justifyContent: "center",
  },
  textatc: {
    fontFamily: "Prompt-Regular",
    fontSize: 15,
    color: "#7764E4",
    alignSelf: "center",
  },
  touchedit: {
    width: 80,
    height: 30,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
    alignSelf: "center",
    justifyContent: "center",
    marginLeft: -80,
  },
  backmodal: {
    flex: 1,
    backgroundColor: "#000000bb",
    justifyContent: "center",
  },
  viewmodal: {
    width: width * 0.7,
    height: 250,
    backgroundColor: "#fff",
    borderRadius: 5,
    alignSelf: "center",
    padding: 10,
  },
  textdel: {
    fontFamily: "Prompt-Regular",
    fontSize: 35,
    color: "#000",
    alignSelf: "center",
  },
  inputmodal: {
    width: width * 0.65,
    height: 50,
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    color: "#777777",
    fontFamily: "Prompt-Regular",
    marginVertical: 10,
    alignSelf: "center",
  },
  touchadd1: {
    width: 150,
    height: 40,
    justifyContent: "center",
    alignSelf: "center",
    borderRadius: 5,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
  },
  textadd: {
    fontFamily: "Prompt-Regular",
    fontSize: 18,
    color: "#172B4D",
    alignSelf: "center",
  },
});
